{
  "familyId": "TGL-GELD-TERUG",
  "questions": [
    {
      "id": "TGL-GELD-TERUG-001",
      "familyId": "TGL-GELD-TERUG",
      "module": "TGL",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Maak precies €3,50 met munten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€3,50", "€3,00", "€4,00", "€3,40"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 350,
          "allowedDenoms": [
            { "valueCents": 200, "type": "coin", "label": "€2" },
            { "valueCents": 100, "type": "coin", "label": "€1" },
            { "valueCents": 50,  "type": "coin", "label": "50 cent" },
            { "valueCents": 20,  "type": "coin", "label": "20 cent" },
            { "valueCents": 10,  "type": "coin", "label": "10 cent" },
            { "valueCents": 5,   "type": "coin", "label": "5 cent" }
          ],
          "constraints": { "maxTokens": 8 }
        }
      },
      "conceptId": "make_amount_basic",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "money",
          "data": { 
            "amount": 350,
            "showCoins": true,
            "label": "Doel: €3,50" 
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoe maak je €3,50?",
            "content": "Begin met de grootste munt die past: €2. Dan nog €1,50 over. Gebruik €1 + 50 cent. Totaal: €2 + €1 + 50c = €3,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: begin met de grootste munt die past en werk naar beneden. Stap 1: pak €2 (grootste munt ≤ €3,50). Stap 2: pak €1 (samen €3). Stap 3: je hebt nog 50 cent nodig — pak 50 cent. Stap 4: tel op: €2 + €1 + 50 cent = €3,50.",
        "distractorExplanations": {
          "0": "Correct! €2 + €1 + 50 cent = €3,50.",
          "1": "Veelgemaakte fout: de centen vergeten. €3,00 is 50 cent te weinig. Je mist nog een 50-cent munt om op €3,50 te komen.",
          "2": "Veelgemaakte fout: een munt te veel pakken. €4,00 is 50 cent te veel. Het moet precies €3,50 zijn, niet meer.",
          "3": "Veelgemaakte fout: de verkeerde munt voor de centen pakken. €3,40 is 10 cent te weinig. Je hebt 50 cent nodig, niet 40 cent."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUG-002",
      "familyId": "TGL-GELD-TERUG",
      "module": "TGL",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Maak precies €5,75 met munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€5,75", "€5,50", "€6,00", "€5,70"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 575,
          "allowedDenoms": [
            { "valueCents": 500, "type": "bill", "label": "€5" },
            { "valueCents": 200, "type": "coin", "label": "€2" },
            { "valueCents": 100, "type": "coin", "label": "€1" },
            { "valueCents": 50,  "type": "coin", "label": "50 cent" },
            { "valueCents": 20,  "type": "coin", "label": "20 cent" },
            { "valueCents": 10,  "type": "coin", "label": "10 cent" },
            { "valueCents": 5,   "type": "coin", "label": "5 cent" }
          ],
          "constraints": { "maxTokens": 10 }
        }
      },
      "conceptId": "make_amount_bills_coins",
      "variantIndex": 2,
      "stimulusAids": [
        {
          "type": "money",
          "data": { 
            "amount": 575,
            "showCoins": true,
            "showBills": true,
            "label": "Doel: €5,75" 
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoe maak je €5,75?",
            "content": "Gebruik het €5-biljet voor het grote deel. Dan nog €0,75 over: 50 cent + 20 cent + 5 cent = 75 cent. Totaal: €5 + 50c + 20c + 5c = €5,75.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: gebruik het biljet voor het grote deel, dan munten voor de rest. Stap 1: pak het €5-biljet. Stap 2: je hebt nog 75 cent nodig: 50 cent + 20 cent + 5 cent = 75 cent. Stap 3: tel op: €5 + 50 cent + 20 cent + 5 cent = €5,75.",
        "distractorExplanations": {
          "0": "Correct! €5 + 50 cent + 20 cent + 5 cent = €5,75.",
          "1": "Veelgemaakte fout: niet genoeg centen erbij. €5,50 is 25 cent te weinig. Je mist nog 20 cent + 5 cent om op 75 cent te komen.",
          "2": "Veelgemaakte fout: afronden naar een rond bedrag. €6,00 is 25 cent te veel. Het moet precies €5,75 zijn.",
          "3": "Veelgemaakte fout: de laatste kleine munt vergeten. €5,70 is 5 cent te weinig. Voeg nog een 5-cent munt toe."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUG-003",
      "familyId": "TGL-GELD-TERUG",
      "module": "TGL",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Een snoepje kost €0,85. Je betaalt met €1,00. Hoeveel wisselgeld krijg je terug?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€0,15", "€0,85", "€0,25", "€0,10"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 85,
          "paidCents": 100,
          "targetCents": 15,
          "allowedDenoms": [
            { "valueCents": 50, "type": "coin", "label": "50 cent" },
            { "valueCents": 20, "type": "coin", "label": "20 cent" },
            { "valueCents": 10, "type": "coin", "label": "10 cent" },
            { "valueCents": 5,  "type": "coin", "label": "5 cent" },
            { "valueCents": 2,  "type": "coin", "label": "2 cent" },
            { "valueCents": 1,  "type": "coin", "label": "1 cent" }
          ],
          "constraints": { "maxTokens": 5 }
        }
      },
      "conceptId": "give_change_simple",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "money",
          "data": { 
            "amount": 100,
            "showCoins": true,
            "label": "Je betaalt €1,00" 
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wisselgeld berekenen",
            "content": "Wisselgeld = betaald − prijs. Hier: €1,00 − €0,85 = €0,15. Dat is 1 munt van 10 cent + 1 munt van 5 cent.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Reken stap voor stap. Stap 1: je betaalt €1,00 en het snoepje kost €0,85. Stap 2: wisselgeld = €1,00 − €0,85 = €0,15. Stap 3: geef terug: 10 cent + 5 cent = 15 cent.",
        "distractorExplanations": {
          "0": "Correct! Wisselgeld = €1,00 − €0,85 = €0,15.",
          "1": "Veelgemaakte fout: de prijs verwarren met het wisselgeld. €0,85 is de prijs van het snoepje zelf, niet het wisselgeld. Wisselgeld = betaald − prijs = €1,00 − €0,85 = €0,15.",
          "2": "Veelgemaakte fout: verkeerd aftrekken. €0,25 is te veel — je rekent misschien €1,00 − €0,75 in plaats van €1,00 − €0,85. Controleer: €1,00 − €0,85 = €0,15.",
          "3": "Veelgemaakte fout: een munt vergeten bij het teruggeven. €0,10 is 5 cent te weinig. Je geeft alleen 10 cent terug, maar je hebt ook nog 5 cent nodig: 10 + 5 = 15 cent."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUG-004",
      "familyId": "TGL-GELD-TERUG",
      "module": "TGL",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Maak precies €2,35 met zo min mogelijk munten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€2,35", "€2,30", "€2,40", "€2,45"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 235,
          "allowedDenoms": [
            { "valueCents": 200, "type": "coin", "label": "€2" },
            { "valueCents": 100, "type": "coin", "label": "€1" },
            { "valueCents": 50,  "type": "coin", "label": "50 cent" },
            { "valueCents": 20,  "type": "coin", "label": "20 cent" },
            { "valueCents": 10,  "type": "coin", "label": "10 cent" },
            { "valueCents": 5,   "type": "coin", "label": "5 cent" }
          ],
          "constraints": { "preferMinimalTokens": true, "maxTokens": 6 }
        }
      },
      "conceptId": "make_amount_minimal",
      "variantIndex": 4,
      "stimulusAids": [
        {
          "type": "money",
          "data": { 
            "amount": 235,
            "showCoins": true,
            "label": "Doel: €2,35" 
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zo min mogelijk munten",
            "content": "Gebruik altijd de grootste munt die past. €2 + 20c + 10c + 5c = €2,35 (4 munten). Dat is de minimale combinatie.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: gebruik zo min mogelijk munten door altijd de grootste munt te pakken die past. Stap 1: pak €2 (grootste munt ≤ €2,35). Stap 2: nog 35 cent over — pak 20 cent (grootste munt ≤ 35). Stap 3: nog 15 cent over — pak 10 cent. Stap 4: nog 5 cent over — pak 5 cent. Totaal: €2 + 20 cent + 10 cent + 5 cent = €2,35 (4 munten).",
        "distractorExplanations": {
          "0": "Correct! €2 + 20 cent + 10 cent + 5 cent = €2,35 (4 munten — minimaal).",
          "1": "Veelgemaakte fout: de laatste kleine munt vergeten. €2,30 is 5 cent te weinig. Je mist nog een 5-cent munt.",
          "2": "Veelgemaakte fout: een munt te veel pakken. €2,40 is 5 cent te veel. Controleer je totaal — je hebt waarschijnlijk een extra 5-cent munt gepakt.",
          "3": "Veelgemaakte fout: twee munten verwisselen. €2,45 is 10 cent te veel. Controleer: 20 + 10 + 5 = 35 cent, niet 45 cent."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUG-005",
      "familyId": "TGL-GELD-TERUG",
      "module": "TGL",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Een broodje kost €2,50. Je betaalt met €5,00. Hoeveel wisselgeld krijg je?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€2,50", "€2,00", "€3,00", "€2,40"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 250,
          "paidCents": 500,
          "targetCents": 250,
          "allowedDenoms": [
            { "valueCents": 200, "type": "coin", "label": "€2" },
            { "valueCents": 100, "type": "coin", "label": "€1" },
            { "valueCents": 50,  "type": "coin", "label": "50 cent" },
            { "valueCents": 20,  "type": "coin", "label": "20 cent" },
            { "valueCents": 10,  "type": "coin", "label": "10 cent" }
          ],
          "constraints": { "maxTokens": 5 }
        }
      },
      "conceptId": "give_change_round",
      "variantIndex": 5,
      "stimulusAids": [
        {
          "type": "money",
          "data": { 
            "amount": 500,
            "showBills": true,
            "label": "Je betaalt €5,00" 
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wisselgeld bij een broodje",
            "content": "Wisselgeld = betaald − prijs = €5,00 − €2,50 = €2,50. Geef terug: €2 + 50 cent.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Reken stap voor stap. Stap 1: je betaalt €5,00 en het broodje kost €2,50. Stap 2: wisselgeld = €5,00 − €2,50 = €2,50. Stap 3: geef terug: €2 + 50 cent = €2,50.",
        "distractorExplanations": {
          "0": "Correct! Wisselgeld = €5,00 − €2,50 = €2,50.",
          "1": "Veelgemaakte fout: de centen vergeten bij het aftrekken. €2,00 is 50 cent te weinig. Je trekt alleen de euro's af (€5 − €2 = €3... nee: €5,00 − €2,50 = €2,50).",
          "2": "Veelgemaakte fout: alleen de euro's aftrekken zonder de centen. €3,00 is 50 cent te veel. Je rekent €5 − €2 = €3, maar vergeet de 50 cent af te trekken.",
          "3": "Veelgemaakte fout: verkeerd aftrekken van de centen. €2,40 is 10 cent te weinig. Controleer: €5,00 − €2,50 = €2,50 (niet €2,40)."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUG-006",
      "familyId": "TGL-GELD-TERUG",
      "module": "TGL",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Maak precies €4,20 met munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€4,20", "€4,00", "€4,30", "€4,10"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 420,
          "allowedDenoms": [
            { "valueCents": 200, "type": "coin", "label": "€2" },
            { "valueCents": 100, "type": "coin", "label": "€1" },
            { "valueCents": 50,  "type": "coin", "label": "50 cent" },
            { "valueCents": 20,  "type": "coin", "label": "20 cent" },
            { "valueCents": 10,  "type": "coin", "label": "10 cent" }
          ],
          "constraints": { "maxTokens": 8 }
        }
      },
      "conceptId": "make_amount_twenties",
      "variantIndex": 6,
      "stimulusAids": [
        {
          "type": "money",
          "data": { 
            "amount": 420,
            "showCoins": true,
            "label": "Doel: €4,20" 
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoe maak je €4,20?",
            "content": "€2 + €2 + 20 cent = €4,20. Of: €2 + €1 + €1 + 20 cent = €4,20. Begin met de grootste munten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: begin met de grootste munt die past en werk naar beneden. Stap 1: pak 2×€2 (samen €4). Stap 2: je hebt nog 20 cent nodig — pak 20 cent. Stap 3: tel op: €2 + €2 + 20 cent = €4,20.",
        "distractorExplanations": {
          "0": "Correct! €2 + €2 + 20 cent = €4,20.",
          "1": "Veelgemaakte fout: de centen vergeten. €4,00 is 20 cent te weinig. Je mist nog een 20-cent munt.",
          "2": "Veelgemaakte fout: de verkeerde munt voor de centen pakken. €4,30 is 10 cent te veel. Je pakte waarschijnlijk 20 cent + 10 cent in plaats van alleen 20 cent.",
          "3": "Veelgemaakte fout: de verkeerde kleine munt pakken. €4,10 is 10 cent te weinig. Je pakte 10 cent in plaats van 20 cent."
        }
      }
    }
  ]
}